import {actions as A} from '../../constants/actions';

export const updateCustomers = (customers) => dispatch => {
  dispatch({
    type: A.UPDATE_CUSTOMERS,
    payload: {customers}
  });
};